import { LoaderFunctionArgs, useLoaderData } from "react-router";
import { getDelegationAcceptLanding } from "../../api/delegation";
import { getDelegationAcceptStartUrl } from "../../constants/delegationAccept";
import { permissionsToLabelString } from "../../constants/delegationPermissions";
import { AcceptDelegationLandingModel } from "../../interfaces/delegation";
import { formatDanishLongDate } from "../../util/date";
import HeaderStandard from "../../components/layouts/HeaderStandard";
import SmallScreenWarningModal from "../../components/Modal/SmallScreenWarningModal";

export const acceptDelegationLoader = async ({
  params,
}: LoaderFunctionArgs): Promise<{
  landing: AcceptDelegationLandingModel;
  token: string;
}> => {
  const token = params.token;
  if (!token) {
    throw new Response("Token mangler", { status: 400 });
  }
  const landing = await getDelegationAcceptLanding(token);
  return { landing, token };
};

export default function AcceptDelegation() {
  const { landing, token } = useLoaderData() as {
    landing: AcceptDelegationLandingModel;
    token: string;
  };

  return (
    <div className="bg-logo text-white min-vh-100 d-flex flex-column">
      <HeaderStandard />
      <div className="row justify-content-center w-100 g-0 flex-grow-1 align-content-center">
        <div className="col col-xl-8 p-3 d-flex flex-column align-items-center gap-4">
          {!landing.valid ? (
            <>
              <h1 className="text-white display-4 text-center mb-2">
                Ugyldig invitation
              </h1>
              <p className="text-center px-4 fw-light lh-lg">
                {landing.errorMessage ||
                  "Invitationen er ugyldig eller udløbet."}
              </p>
            </>
          ) : (
            <>
              <h1
                className="text-white display-1 text-center mb-3"
                style={{ fontSize: "2.75rem" }}
              >
                Invitation til fuldmagt login
              </h1>
              <div className="text-center px-4 fw-light lh-lg">
                <p>
                  Du er inviteret til at logge ind og handle på vegne af{" "}
                  <strong className="fw-semibold">{landing.lawyerName}</strong>{" "}
                  i Advokatsamfundets indberetningsportal.
                </p>
                <p>
                  <strong className="fw-semibold">Rettigheder:</strong>{" "}
                  {permissionsToLabelString(landing.permissions)}
                </p>
                <p>
                  <strong className="fw-semibold">Invitationen udløber:</strong>{" "}
                  {formatDanishLongDate(landing.expiresAt)}
                </p>
                <p>
                  <strong className="fw-semibold">Fuldmagten udløber:</strong>{" "}
                  {landing.delegationValidTo
                    ? `${formatDanishLongDate(landing.delegationValidTo)}`
                    : "Har ingen udløbsdato"}
                </p>
              </div>
              <a
                id="delegation-accept-start"
                href={getDelegationAcceptStartUrl(token)}
                className="btn btn-light btn-lg fw-semibold col-12 col-sm-auto px-5"
                aria-label="Accepter med MitID"
              >
                Accepter med MitID
              </a>
            </>
          )}
        </div>
      </div>
      <SmallScreenWarningModal />
    </div>
  );
}
